import { useRecordContext } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { DataTable } from "@/components/admin/data-table";
import { ExportButton } from "@/components/admin/export-button";
import { List } from "@/components/admin/list";
import { ListPagination } from "@/components/admin/list-pagination";
import { SearchInput } from "@/components/admin/search-input";

import { TopToolbar } from "../layout/TopToolbar";
import type { Sale } from "../types";
import { ROLE_OPTIONS } from "./SalesInputs";

const ROLE_BADGE: Record<string, string> = {
  admin:        "bg-blue-100 text-blue-800",
  manager:      "bg-purple-100 text-purple-800",
  sales:        "bg-green-100 text-green-800",
  merchandiser: "bg-orange-100 text-orange-800",
  finance:      "bg-yellow-100 text-yellow-800",
};

const SalesListActions = () => (
  <TopToolbar>
    <ExportButton />
    <CreateButton label="resources.sales.action.new" />
  </TopToolbar>
);

const filters = [<SearchInput source="q" alwaysOn />];

const RoleField = (_props: { label?: string | boolean }) => {
  const record = useRecordContext<Sale>();
  if (!record) return null;

  // Determine effective role
  const role = record.administrator ? "admin" : (record.role ?? "sales");
  const option = ROLE_OPTIONS.find((o) => o.value === role);
  const label = option?.label.split("（")[0] ?? role; // short label before the bracket

  return (
    <div className="flex flex-row gap-1 flex-wrap">
      <span className={`inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium ${ROLE_BADGE[role] ?? "bg-gray-100 text-gray-600"}`}>
        {label}
      </span>
      {record.disabled && (
        <span className="inline-flex items-center text-xs px-2 py-0.5 rounded-full font-medium border border-orange-300 text-orange-700">
          已停用
        </span>
      )}
    </div>
  );
};

export function SalesList() {
  return (
    <List
      filters={filters}
      actions={<SalesListActions />}
      sort={{ field: "first_name", order: "ASC" }}
      perPage={50}
      pagination={<ListPagination rowsPerPageOptions={[10, 25, 50]} />}
    >
      <DataTable>
        <DataTable.Col source="first_name" />
        <DataTable.Col source="last_name" />
        <DataTable.Col source="email" />
        <DataTable.Col label="角色" source="role">
          <RoleField />
        </DataTable.Col>
      </DataTable>
    </List>
  );
}
